const { default: axios } = require("axios");

const Notification = function () {

    const allowedEnvs = [
        'concivil',
        'nls',
        'engelux',
        'hydepark',
        'agart',
        'engeluxcrm',
        'requadra',
        'viewco',
        'veigajunior',
    ];

    const startWS = () => {
        if (user_logged_id == 0 || active_notifications === 0) {
            return;
        }

        Echo.private("notification." + client_name)
            .listen('SendNotification', (response) => {
                axios.post(window.location.origin + "/notification/hub", response)
                    .then(function (response) {
                        const data = response.data;
                        $('.btn-notif').addClass('pulse');
                        document.getElementById('audio-notification').play();
                    });
            })
            .listen('NotificationEvent', (response) => {
                if (user_logged_id == response.user_id) {
                    axios.post(window.location.origin + "/notification/recive", response)
                        .then(function (response) {
                            const data = response.data;
                            if (data.error == false) {
                                $('.btn-notif').addClass('pulse');
                                document.getElementById('audio-notification').play();    
                            }                            
                        });
                }
            });
    }

    const beams = () => {

        if ($.inArray(client_name, allowedEnvs) > 0 && window.location.pathname == "/login") {
            const beamsClient = new PusherPushNotifications.Client({
                instanceId: '9f2735cb-c69f-4e02-b83c-820c1f1d0902',
            });

            beamsClient
                .start()
                .then((beamsClient) => beamsClient.getDeviceId())
                .then((deviceId) =>
                    console.log("Successfully registered with Beams. Device ID:", deviceId)
                )
                .then(() => beamsClient.clearAllState())
                .then(() => beamsClient.clearDeviceInterests())
                .catch(console.error);
        }

        if (user_logged_id == 0 || active_notifications === 0) {
            return;
        }

        if ($.inArray(client_name, allowedEnvs) === -1) {
            return;
        }

        const beamsClient = new PusherPushNotifications.Client({
            instanceId: '9f2735cb-c69f-4e02-b83c-820c1f1d0902',
        });

        const interest = client_name + '-' + user_logged_id;

        beamsClient
            .start()
            .then((beamsClient) => beamsClient.getDeviceId())
            .then((deviceId) =>
                console.log("Successfully registered with Beams. Device ID:", deviceId)
            )
            .then(() => beamsClient.addDeviceInterest(interest))
            .then(() => beamsClient.getDeviceInterests())
            .then((interests) => console.log("Current interests:", interests))
            .catch(console.error);
    }

    return {
        init: () => {
            startWS();
            beams();
        }
    }
}();

module.exports = Notification;